import { Action } from '../features/Poly';
import { FillStyle, PolyRender } from '../renders/Poly';
import { registerSymbol } from '../serializers/symbolSerializer';
import { getRenderedPolygonCoordinates, simplifyCoordinates } from '../utils/math';
import { getParameterValue } from "../utils/utils";
import { Symbol } from './Symbol';
import { CombinedPolyline } from "../features/CombinedPolyline";
/**
 * Symbol of polyline drawn as simple line.
 * @alias sGis.symbol.polyline.Combined
 */
export class CombinedPolylineSymbol extends Symbol {
    /**
     * @param options - key-value list of the properties to be assigned to the instance.
     */
    constructor(options = {}) {
        super();
        /** Values of the symbol. */
        this.values = [];
        Object.assign(this, options);
    }
    renderFunction(feature, resolution, crs) {
        const result = [];
        if (!(feature instanceof CombinedPolyline))
            return result;
        const coordinates = this.getRenderedCoordinates(feature, resolution, crs);
        this.values.forEach(polyline => {
            result.push(new PolyRender(coordinates, {
                fillStyle: FillStyle.Color,
                enclosed: false,
                strokeColor: polyline.stroke.color,
                strokeWidth: getParameterValue(polyline.stroke.width),
                lineDash: getParameterValue(polyline.stroke.intervals),
                shadow: null,
                lineCap: polyline.lineCap,
                lineJoin: polyline.lineJoin,
                miterLimit: polyline.miterLimit,
            }));
        });
        return result;
    }
    /**
     * Projects coordinates of a poly feature to the requested crs and resolution.
     * @param feature
     * @param resolution
     * @param crs
     * @param tolerance
     */
    getRenderedCoordinates(feature, resolution, crs, tolerance) {
        let result;
        if (this.previousPoly === feature
            && this.previousCrs.equals(crs)
            && this.previousResolution === resolution
            && feature.lastAction
            && feature.lastAction.type !== Action.removePoint) {
            const lastAction = feature.lastAction;
            let newResult = this.previousSimplified;
            if (lastAction.type === Action.movePoint) {
                const newSimplifiedRing = simplifyCoordinates([feature.rings[lastAction.ringIndex]].map(ring => {
                    return ring.map(point => {
                        return [Math.round(point[0] / resolution), Math.round(point[1] / -resolution)];
                    });
                }), tolerance);
                newResult[lastAction.ringIndex] = newSimplifiedRing[0];
            }
            if (lastAction.type === Action.addPoint) {
                const renderCoordinates = [
                    Math.round(lastAction.coordinates[0] / resolution),
                    Math.round(lastAction.coordinates[1] / -resolution),
                ];
                newResult[lastAction.ringIndex].push(renderCoordinates);
            }
            result = newResult;
        }
        else {
            result = getRenderedPolygonCoordinates(feature, resolution, crs, tolerance);
        }
        this.previousSimplified = result;
        this.previousPoly = feature;
        this.previousCrs = crs;
        this.previousResolution = resolution;
        feature.lastAction = null;
        return result;
    }
}
registerSymbol(CombinedPolylineSymbol, 'polyline.Combined', ['values']);
